<template>
  <div>
    <PageTitle
      title="Quotation Details"
      :backBtn="true"
      :createSale="true"
      @onClickCreateSale="makeQuotationtoSales"
    />
    <v-container fluid class="lighten-12 container">
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="9">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-sale</v-icon
                  ><span class="ml-3"> Quotation Details</span></v-card-title
                >
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row class="pt-0">
                        <v-col
                          cols="12"
                          sm="12"
                          md="4"
                          lg="4"
                          class="pr-5pt-1.5 pb-1 reference_number"
                        >
                          <v-icon>mdi-sale</v-icon>
                          {{
                            quotation.reference_number
                              ? quotation.reference_number
                              : '----'
                          }}
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="3"
                          lg="3"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Shop </v-row>
                          <v-row>
                            {{ quotation.shop ? quotation.shop.name : '----' }}
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Biller </v-row>
                          <v-row>
                            {{
                              quotation.biller
                                ? quotation.biller.first_name
                                : '----'
                            }}
                          </v-row>
                        </v-col>

                        <v-col cols="1" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Sale Date </v-row>
                          <v-row>
                            <v-icon small>mdi-calendar</v-icon>
                            {{ quotation.date | formatDate }}
                          </v-row>
                        </v-col>

                        <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Customer </v-row>
                          <v-row>
                            {{
                              quotation.customer
                                ? quotation.customer.name
                                : '----'
                            }}
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small
                    >mdi-checkbox-marked-circle-outline</v-icon
                  ><span class="ml-3"> Sales Items</span></v-card-title
                >
                <v-container fluid class="container saledetailscard">
                  <v-row
                    v-for="saleitem in quotation.quotationItem"
                    :key="saleitem"
                    class="saletiltle"
                  >
                    <!-- {{saleitem}} -->
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row>
                        <v-col
                          cols="12"
                          sm="12"
                          md="3"
                          lg="3"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Item </v-row>
                          <v-row>
                            {{
                              saleitem.product ? saleitem.product.name : '----'
                            }}
                          </v-row>
                        </v-col>
                        <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="2"
                          lg="2"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Unit </v-row
                          ><v-row>
                            {{ saleitem.unit ? saleitem.unit.name : '----' }}
                          </v-row>
                          <v-row class="subtextlable"> Batch </v-row
                          ><v-row>
                            {{ saleitem.batch ? saleitem.batch.batch : '----' }}
                          </v-row>
                        </v-col>

                        <v-col cols="12" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="1"
                          lg="1"
                          class="shoptext pr-5 pt-0"
                        >
                          <v-row class="subtextlable"> Quantity </v-row>
                          <v-row>
                            {{ saleitem.quantity ? saleitem.quantity : '----' }}
                          </v-row>
                        </v-col>

                        <v-col cols="1" sm="12" md="1" lg="1" class="shoptext">
                          <v-divider></v-divider>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="12"
                          md="3"
                          lg="3"
                          class="shoptext pr-2 pt-0"
                        >
                          <v-row class="pt-0">
                            <v-col
                              cols="12"
                              sm="12"
                              md="5"
                              lg="5"
                              class="subtextlable"
                            >
                              Unit Rate
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="7"
                              lg="7"
                              style="text-align: right"
                            >
                              LKR
                              {{ saleitem.amount | formatCurrency }}
                            </v-col>
                          </v-row>

                          <v-row class="pt-0">
                            <v-col
                              cols="12"
                              sm="12"
                              md="5"
                              lg="5"
                              class="subtextlable"
                            >
                              Bargain Discount
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="7"
                              lg="7"
                              style="text-align: right"
                            >
                              LKR
                              {{
                                saleitem.batch.bargain_discount | formatCurrency
                              }}
                            </v-col>
                          </v-row>
                          <v-row class="pt-0">
                            <v-col
                              cols="12"
                              sm="12"
                              md="5"
                              lg="5"
                              class="subtextlable"
                            >
                              Sub Total
                            </v-col>
                            <v-col
                              cols="12"
                              sm="12"
                              md="7"
                              lg="7"
                              style="text-align: right"
                            >
                              LKR
                              {{
                                (saleitem.amount * saleitem.quantity -
                                  saleitem.discount)
                                  | formatCurrency
                              }}
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
          <v-row> </v-row>
        </v-col>

        <v-col>
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12">
              <v-card class="lighten-12">
                <v-card-title class="v-card__title saletiltle"
                  ><v-icon color="blue" small>mdi-cash-multiple</v-icon>
                  <span class="ml-3">Payment Summary</span>
                </v-card-title>
                <v-container fluid class="container saledetailscard">
                  <v-row>
                    <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                      <v-row class="pt-0">
                        <v-col
                          cols="5"
                          sm="12"
                          md="5"
                          lg="5"
                          class="paymenttext"
                        >
                          Total
                        </v-col>
                        <v-col
                          cols="7"
                          sm="12"
                          md="7"
                          lg="7"
                          class="saletiltle"
                          style="text-align: right"
                        >
                          LKR
                          {{ quotation.total | formatCurrency }}
                        </v-col>
                      </v-row>
                      <v-divider></v-divider>
                      <v-row class="pt-0">
                        <v-col
                          cols="5"
                          sm="12"
                          md="5"
                          lg="5"
                          class="paymenttext"
                        >
                          Discount
                        </v-col>
                        <v-col
                          cols="7"
                          sm="12"
                          md="7"
                          lg="7"
                          class="saletiltle"
                          style="text-align: right"
                        >
                          LKR
                          {{
                            quotation.discount_amount
                              ? quotation.discount_amount
                              : 0
                          }}
                        </v-col>
                      </v-row>
                      <v-row
                        class="blue darken-1 white--text font-weight-black title"
                      >
                        <v-col
                          cols="5"
                          sm="12"
                          md="5"
                          lg="5"
                          class="saletiltle"
                          style="font-weight: bold; font-size: 15px"
                        >
                          Grand Total
                        </v-col>
                        <v-col
                          cols="7"
                          sm="12"
                          md="7"
                          lg="7"
                          class="saletiltle"
                          style="
                            text-align: right;
                            font-weight: bold;
                            font-size: 15px;
                          "
                        >
                          LKR
                          {{
                            (quotation.total
                              ? quotation.total
                              : 0 - quotation.discount_amount
                                ? quotation.discount_amount
                                : 0) | formatCurrency
                          }}
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from '@/plugins/axios';
import confirmation from '@/modules/shared/components/confirmation';

export default {
  data: () => ({
    quotation: {},
    salesItems: [],
    isLoading: false,
  }),
  methods: {
    makeQuotationtoSales() {
      confirmation.dialog = true;
      this.$confirm('Do you want to make this quotation to sale?').then(
        (res) => {
          if (res) {
            this.confirmSaleItems();
          }
        },
      );
    },
    confirmSaleItems() {
      this.quotation.quotationItem.map((item) => {
        this.salesItems.push({
          quantity: item.quantity,
          selectedProdct: { name: item.product.name, id: item.product.id },
          productid: item.product.id,
          batch_id: item.batch.id,
          unit_id: item.unit.id,
          units: [item.unit],
          batches: [item.batch],
          selectedBatch: item.batch,
          selectedUnit: item.unit,
          amount: item.amount,
          discount: item.discount,
          ProductVisible: false,
        });
      });

      this.gotoSaleSection();
    },
    gotoSaleSection() {
      this.$store.commit('UPDATE_SALES_PRODUCTS', this.salesItems);
      this.$store.commit('UPDATE_SALES_QUOTATION', true);
      this.$store.commit('UPDATE_SALES_DETAILS', {
        customer_id: this.quotation?.customer.id,
        shop_id: this.quotation?.shop.id,
        searchShop: this.quotation.shop.name,
        searchCustomer: this.quotation.customer.name,
      });
      this.$router.push({ path: '/sales/new' });
    },
    Getquotation() {
      let id = this.$route.params.id;

      axios
        .get(`pos/quotations/${id}`)
        .then((res) => {
          this.quotation = res.data.data;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.messages = err.data.title;
        });
    },
  },

  created() {
    this.Getquotation();
  },
  computed: {},
};
</script>

<style scoped>
.orderData {
  font-weight: bold;
}
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
  padding: 0 !important;
  padding-left: 10px !important;
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 13px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: center;

  color: #045894;
}
</style>
